import config from 'config';
export const STORE_PARAMS = 'STORE_PARAMS';

export const storeParams = payload => {
  return {
    type: STORE_PARAMS,
    payload,
  };
};

// ------------------------------------
// Action Handlers
// ------------------------------------

const ACTION_HANDLERS = {
  [STORE_PARAMS]: (state, action) => {
    return {
      ...state,
      params: action.payload,
    };
  },
};

export const initialState = {
  name: 'anon.web',
  version: config.APP_VERSION,
  platform: 'browser',
  params: {},
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function appReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
